export default ({ color, fontSize, typography }) => ({
  root: {
    padding: '3% 0%',
  },
  choice: {
    marginRight: 5,
    width: 100,
    fontFamily: 'clear-sans-regular',
    fontWeight: 'normal',
    cursor: 'pointer',
    '& span': {
      display: 'inherit !important',
      paddingLeft: '0 !important',
    },
  },
  dataRangeLabel: {
    color: color.pageTitle,
    fontSize: fontSize.title,
    fontFamily: typography.pageTitle,
  },
  radioGroup: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
  },
  radioGroupRoot: {
    flexDirection: 'row',
  },
  radioLabelRoot: {
    display: 'inline',
  },
  customRadioBtn: {
    '& span': {
      display: 'inherit !important',
      paddingLeft: '0 !important',
      cursor: 'pointer',
    },
  },
});
